import instance from '@/helpers/axios'

const state = {
  isLoading: false,
  tatics: [],
  update_date: null
}

// getters
const getters = {
  isLoading: state => {
    return state.isLoading;
  },
  tatics: state => {
    return state.tatics;
  },
  update_date: state => {
    return state.update_date
  }
}

// mutations
const mutations = {
  SET_LOADING (state, loading) {
    state.isLoading = loading
  },
  SET_TATICS (state, tatics) {
    state.tatics = tatics
  },
  SET_UPDATE_DATE (state, update_date) {
    state.update_date = update_date
  }
}

// actions
const actions = {
  getTaticDatas(context) {
    context.commit('SET_LOADING', true)

    instance.get('tatics')
      .then(response => {
        context.commit('SET_LOADING', false)
        context.commit('SET_TATICS', response.data.rows)
      })
      .catch(error => {
        console.log(error.response, "[store/tatic] errors under instant.get");
      })
  },
  getUpdateDate(context) {
    instance.get('tatics/updated_date')
      .then(response => {
        context.commit('SET_UPDATE_DATE', response.data)
      })
      .catch(error => {
        console.log(error.response, "[store/tatic/updated_date] errors under instant.get");
      })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}